import React, { useState } from 'react';
import ButtonsSearch from '../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../components/NovoSistema/ContainerSection';
import InputDate from '../../../../../../../components/NovoSistema/InputDate';
import DoubleInput from '../../../../../../../components/NovoSistema/DoubleInput';
import { WrapperInputsNewSystem } from '../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function ConsultaDeSaldoKardexSearch() {
  const [showOrHideSaldo, setShowOrHideSaldo] = useState(true);
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
          <InputDate title="Período Inicial" id="PeriodoInicial" widthPercentage="20%" />
          <InputDate title="Período Final" id="PeriodoFinal" widthPercentage="20%" />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
      <ContainerSection>
        <h3 onClick={() => setShowOrHideSaldo((e) => !e)}>{showOrHideSaldo ? '-  ' : '+ '}Saldos</h3>
        {showOrHideSaldo && (
          <div>
            <ContainerSection>
              <h3>Saldo Atual</h3>
              <WrapperInputsNewSystem>
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Quantidade</th>
                      <th>Custo Médio</th>
                      <th>Preço Atual</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Real</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Reservas</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Troca</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Disponível</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Uso e Consumo</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                  </tbody>
                </table>
              </WrapperInputsNewSystem>
            </ContainerSection>
            <ContainerSection>
              <h3>Saldo do Período</h3>
              <WrapperInputsNewSystem>
                <table style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Quantidade</th>
                      <th>Custo Médio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Saldos Iniciais</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Saldos Finais</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Totais das Entradas</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                    <tr>
                      <td>Totais das Saídas</td>
                      <td style={{ textAlign: 'center' }}>0,0000</td>
                    </tr>
                  </tbody>
                </table>
              </WrapperInputsNewSystem>
            </ContainerSection>
            <ContainerSection>
              <h3>Média unitária ICMS ST Retido Anteriormente</h3>
              <WrapperInputsNewSystem>
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr>
                      <td>Média unitária da Base do</td>
                      <td style={{ textAlign: 'center' }}>Não Calculado</td>
                      <td style={{ textAlign: 'center' }}>Cálculo/Notas</td>
                    </tr>
                    <tr>
                      <td>ICMS ST Retido</td>
                    </tr>
                    <tr>
                      <td>Anteriormente</td>
                    </tr>
                    <tr>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Média unitária do Valor do </td>
                      <td style={{ textAlign: 'center' }}>Não Calculado</td>
                    </tr>
                    <tr>
                      <td>ICMS ST Retido</td>
                    </tr>
                    <tr>
                      <td>Anteriormente</td>
                    </tr>
                  </tbody>
                </table>
              </WrapperInputsNewSystem>
            </ContainerSection>
          </div>
        )}
      </ContainerSection>
      <ContainerSection>
        <h3>Kardex</h3>
        <WrapperInputsNewSystem></WrapperInputsNewSystem>
      </ContainerSection>
    </div>
  );
}
